<template>
  <div class="order-container">
    <Header title="客存查询"></Header>
    <Search @onSearch="onSearch" @onCancel="onCancel" :keyName="keyName"></Search>
    <Scroll
      ref="wrapper"
      :listenScroll="false"
      :pullUpLoad="pullUpLoadObj"
      @pullingUp="onPullUpLoad"
      :pullDownRefresh="pullDownRefreshObj"
      @pullingDown="onPullDownRefresh"
    >
      <GuestDepositCard :orderList ="orderList"></GuestDepositCard>
      <van-empty
        v-if="dataEmpty"
        class="custom-empty"
        description="暂无数据"
      ></van-empty>
    </Scroll>

    <!-- <van-popup
      v-model="filterFlag"
      position="right"
      :overlay="true"
    >
      <FilterList
        :brandList="brandList"
        @refreshData="refreshData"
      ></FilterList>
    </van-popup> -->

  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Search from "./components/Search.vue";
import GuestDepositCard from "./components/GuestDepositCard";
// import FilterList from "./components/FilterList";
import transactionApi from "@/request/transactionApi";
// import commonApi from "@/request/commonApi";
import Scroll from "@/components/Scroll";
export default {
  name: "GuestDeposit",
  components: {
    Header,
    Search,
    GuestDepositCard,
    // FilterList,
    Scroll,
  },
  data() {
    return {
      keyName: "交货单号",
      orderStatus: "0",
      filterFlag: false,
      orderList: [],
      brandList: [],
      hasNextPage: true,
      scrollParams: {
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "",
        pullUpLoadNoMoreTxt: "",
      },
      form: {
        deliveryCode: "", //交货单号
        materialCode:"",//商品编号
        queryType:"",//查询类型
        buyerName: "", //买家名称
        commodityName: "", //产品名称
        deliveryAddress: "", //交货地
        warehouseName: "", //仓库
        orderDateStart: "", //订单开始时间
        orderDateEnd: "", //订单结束事件
        sellerName:"", //卖家名称
      },
      formPage: {
        pageSize: 10,
        currentPage: 1,
        totalRows: 0,
      },
    };
  },
  computed: {
    pullUpLoadObj() {
      return this.scrollParams.pullUpLoad
        ? {
            threshold: parseInt(this.scrollParams.pullUpLoadThreshold),
            txt: {
              more: this.scrollParams.pullUpLoadMoreTxt,
              noMore: this.scrollParams.pullUpLoadNoMoreTxt,
            },
          }
        : false;
    },
    pullDownRefreshObj() {
      return this.scrollParams.pullDownRefresh
        ? {
            threshold: parseInt(this.scrollParams.pullDownRefreshThreshold),
            stop: parseInt(this.scrollParams.pullDownRefreshStop),
          }
        : false;
    },
    dataEmpty() {
      return this.orderList.length == 0 && !this.loading;
    },
  },
  watch: {},
  created() {
    this.getOrderList();
  },
  methods: {
    onFilter() {
      this.filterFlag = !this.filterFlag;
    },
    onSearch(val) {
      this.form.deliveryCode =val;
      this.orderList = [];
      this.getOrderList();
    },
    onCancel(val) {
      this.form.deliveryCode =val;
      this.getOrderList();
    },
    //上拉加载
    onPullUpLoad() {
      if (!this.hasNextPage) {
        this.$refs.wrapper.forceUpdate(false);
        return false;
      } else {
        setTimeout(() => {
          this.formPage.currentPage++;
          this.getOrderList();
        }, 1000);
      }
    },
    //下拉刷新
    onPullDownRefresh() {
      setTimeout(() => {
        this.formPage.currentPage = 1;
        // this.orderList = [];
        this.getOrderList();
      }, 1000);
    },
    refreshData(queryList) {
      this.onFilter();
      this.searchForm = this.$options.data().searchForm;
      for (let i = 0; i < queryList.length; i++) {
        let item = queryList[i];
        if (item.key == "commodityName") {
          let productTypes = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (productTypes.length > 0) {
            this.searchForm.productLine = productTypes[0].key;
          }
          continue;
        }
        if (item.key == "sellers") {
          let sellers = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (sellers.length > 0) {
            this.searchForm.sellerEnterpriseCode = sellers[0].key;
          }
          continue;
        }
        if (item.key == "orderType") {
          let types = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (types.length > 0) {
            this.searchForm.tradeType = types[0].key;
          }
          continue;
        }
        if (item.key == "orderStatus") {
          let status = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (status.length > 0) {
            this.Pagedata.status = status[0].key;
          }
          continue;
        }
      }

      this.orderList = [];
      this.formPage.currentPage = 1;
      this.getOrderList();
    },
    async getOrderList() {
      let params = Object.assign({}, this.formPage, this.form);
      delete params.totalRows;
      transactionApi.getCustomerList(params).then((res) => {
        if (res.returnCode == "0") {
          this.orderList = res.result.dataList;
          // this.Pagedata.currentPage++;
          this.hasNextPage = res.result.hasNextPage;
          if (this.hasNextPage) {
            this.$refs.wrapper.forceUpdate(true);
          } else {
            this.$refs.wrapper.forceUpdate(false);
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    
  },
};
</script>
<style lang="stylus" scoped>
.order-container >>> .van-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-container >>> .van-tabs__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// .order-container >>> .van-tabs__content .van-tab__pane {
// flex: 1;
// overflow: hidden;
// display: flex;
// flex-direction: column;
// }

// .order-container >>> .van-tabs__content .van-tab__pane .van-pull-refresh {
// flex: 1;
// display: flex;
// flex-direction: column;
// overflow: auto;
// }
.order-container >>> .van-tabs .van-tabs__wrap {
  height: 88px;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab {
  font-size: 32px;
  line-height: 45px;
  color: #333333;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab--active {
  // font-size: 36px;
  color: #E12020;
}

.order-container >>> .van-popup {
  height: 100%;
  width: 576px;
}

.order-container >>> .van-empty__image {
  width: 360px;
  height: 360px;
}

.order-container >>> .van-empty__description {
  font-size: 0.32rem;
  line-height: 0.38rem;
}

.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tabs-container {
    flex: 1;
    display: flex;
    overflow: hidden;
  }
}
</style>